import { render } from "./Busines.vue?vue&type=template&id=a8ed4a3c"
import script from "./Busines.vue?vue&type=script&lang=js"
export * from "./Busines.vue?vue&type=script&lang=js"
script.render = render

export default script